import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Service Center Space Assignment: The association(s) between service centers and space.',
    name: 'Service Center Space Assignments',
    partialId: PartialId.Standard.create('svc_center_space'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
